import React from 'react'

import { FormDataConsumer } from 'react-admin'

export const FormProvider: React.FC = ({ children }) => (
  <FormDataConsumer>
    {({ formData, ...others }) => (
      <>
        {children && (
          <>
            {React.cloneElement(children as React.ReactElement<any>, {
              formData,
            })}
          </>
        )}
      </>
    )}
  </FormDataConsumer>
)
